import { defineComponent as c, ref as u, onMounted as x, createBlock as m, openBlock as s, resolveDynamicComponent as v, normalizeClass as E, withCtx as i, createVNode as g, Transition as k, createElementBlock as n, withDirectives as w, Fragment as C, createCommentVNode as B, renderSlot as d, vShow as N } from "vue";
const z = /* @__PURE__ */ c({
  name: "ll-expand",
  __name: "Expand",
  props: {
    is: { default: "div" },
    isExpanded: { type: Boolean, default: !1 },
    isLazy: { type: Boolean, default: !1 },
    transitionName: { default: "expand" }
  },
  emits: ["after-expand"],
  setup(l, { emit: r }) {
    const o = l, p = r, t = u(null);
    x(() => {
      !o.isExpanded && t.value && (t.value.style.overflow = "hidden");
    });
    const f = (e) => {
      e.style.visibility = "hidden", e.style.height = "auto";
      const a = e.offsetHeight;
      e.style.visibility = "", e.style.display = "", e.style.height = 0, requestAnimationFrame(() => {
        e.style.height = `${a}px`;
      });
    }, h = (e) => {
      e.style.height = "", e.style.overflow = "", p("after-expand");
    }, y = (e) => {
      const a = e.offsetHeight;
      e.style.height = `${a}px`, e.style.overflow = "hidden", requestAnimationFrame(() => {
        e.style.height = 0;
      });
    };
    return (e, a) => (s(), m(v(o.is), {
      class: E(["stash-expand", {
        "stash-expand--expanded": e.isExpanded,
        "stash-expand--collapsed": !e.isExpanded
      }]),
      "data-test": "stash-expand"
    }, {
      default: i(() => [
        g(k, {
          name: e.transitionName,
          onAfterEnter: h,
          onEnter: f,
          onLeave: y
        }, {
          default: i(() => [
            e.isLazy ? (s(), n(C, { key: 0 }, [
              e.isExpanded ? (s(), n("div", {
                key: 0,
                ref_key: "contentRef",
                ref: t
              }, [
                d(e.$slots, "default")
              ], 512)) : B("", !0)
            ], 64)) : w((s(), n("div", {
              key: 1,
              ref_key: "contentRef",
              ref: t
            }, [
              d(e.$slots, "default")
            ], 512)), [
              [N, e.isExpanded]
            ])
          ]),
          _: 3
        }, 8, ["name"])
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  z as _
};
//# sourceMappingURL=Expand.vue_vue_type_script_setup_true_lang-CiONJfAp.js.map
